import { FC } from 'react';

import { A11yCopy, Alert, Copy, Inline } from '@belong/ui-components';

import { LIVE_CHAT_TEST_IDS } from '../../lib/testIds';
import CONTENT from '../content.json';
import { StatusWrapper, UploadSpinner } from './AttachmentStatus.styles';

const { uploadStatus } = CONTENT;

interface IAttachmentStatus {
  dismissError: () => void;
  error?: string;
  isLoading: boolean;
}

export const AttachmentStatus: FC<IAttachmentStatus> = ({ error, dismissError, isLoading }) => {
  return (
    <>
      <A11yCopy aria-live="polite">{isLoading ? uploadStatus.uploading : ''}</A11yCopy>
      {isLoading || error ? (
        <StatusWrapper data-testid={LIVE_CHAT_TEST_IDS.ATTACHMENT_STATUS}>
          {isLoading ? (
            <Inline space="medium">
              <UploadSpinner />
              <Copy>{uploadStatus.uploading}</Copy>
            </Inline>
          ) : null}
          {error && !isLoading ? (
            <Alert position="BLOCK" type="ERROR" onDismiss={dismissError} hasFocus isDismissable>
              <Copy>{error}</Copy>
            </Alert>
          ) : null}
        </StatusWrapper>
      ) : null}
    </>
  );
};
